import { combineReducers } from 'redux';

import { geoserverApi } from '../api/geoserverApi';
import { itascaApi } from '../api/itascaserverApi';
import boundaryTransferSlice from '../slices/boundaryTransfer';
import claimMyLandModalSlice from '../slices/claimMyLandSlice';
import contactUsTransferSlice from '../slices/contactUsTransferSlice';
import customizeMyLandSlice from '../slices/customizeMyLandSlice';
import drawV2Slice from '../slices/drawV2Slice';
import featureSlice from '../slices/featureSlice';
import fileUploadModalSlice from '../slices/fileUploadModalSlice';
import imageDisplaySlice from '../slices/imageDisplaySlice';
import landSelectionsSlice from '../slices/landSelectionsSlice';
import mapBoxDrawSlice from '../slices/mapBoxDrawSlice';
import modalHandlerSlice from '../slices/modalHandlerSlice';
import modalSlice from '../slices/modalSlice';
import reportPanelSlice from '../slices/reportPanelSlice';
import savedSelectionSlice from '../slices/savedSelectionSlice';
import searchSlice from '../slices/searchSlice';
import settingsSlice from '../slices/settingsSlice';
import toastSlice from '../slices/toastSlice';
import waterInfoSlice from '../slices/waterInfo';

export const CLEAR_STATE_ACTION = {
  type: 'CLEAR_STATE',
};

const appReducer = combineReducers({
  boundaryTransfer: boundaryTransferSlice,
  claimMyLand: claimMyLandModalSlice,
  contactUsTransfer: contactUsTransferSlice,
  customizeMyLand: customizeMyLandSlice,
  draw: mapBoxDrawSlice,
  drawV2: drawV2Slice,
  features: featureSlice,
  fileUploadModal: fileUploadModalSlice,
  imageDisplay: imageDisplaySlice,
  landSelections: landSelectionsSlice,
  modal: modalSlice,
  modalHandler: modalHandlerSlice,
  reportPanel: reportPanelSlice,
  savedSelection: savedSelectionSlice,
  search: searchSlice,
  settings: settingsSlice,
  toast: toastSlice,
  waterInfo: waterInfoSlice,
  [geoserverApi.reducerPath]: geoserverApi.reducer,
  [itascaApi.reducerPath]: itascaApi.reducer,
});

const rootReducer = (state, action) =>
  appReducer(
    action.type === CLEAR_STATE_ACTION.type ? undefined : state,
    action
  );

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
